import { useAction, useAtom } from '@reatom/npm-react'
import { useId } from 'react'
import styled from 'styled-components'

import { Button, Refresh2Icon } from '@blade/ui-kit'
import { exploreFilterDrawer } from '@root/features/explore/atoms/reatom-explore-filter-drawer'
import { useTranslation } from '@root/shared/localization'
import { Separator, Drawer } from '@root/shared/ui-kit'

import { ExploreFilterForm } from '../explore-filter-form'

import type { ExploreFiltersAtom } from '../../../atoms'
import type { ClassNameProps } from '@root/shared/react'
import type { FormEvent } from 'react'

type Props = {} & ClassNameProps

// Mobile drawer
export const ExploreFilterDrawer: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const [exploreFiltersModel] = useAtom(exploreFilterDrawer.exploreFilterDrawer)
  const closeExploreFiltersDrawer = useAction(exploreFilterDrawer.closeAction)

  return (
    <Drawer
      title={t('common.filter_other')}
      className={className}
      open={exploreFiltersModel !== undefined}
      onOpenChange={() => closeExploreFiltersDrawer()}
    >
      {exploreFiltersModel ? (
        <DrawerContent>
          <ExploreFilterDrawerForm
            model={exploreFiltersModel}
            onClose={closeExploreFiltersDrawer}
            onSubmit={closeExploreFiltersDrawer}
          />
        </DrawerContent>
      ) : undefined}
    </Drawer>
  )
}

const DrawerContent = styled.div`
  overflow: auto;
`

type FormProps = {
  model: ExploreFiltersAtom
  onSubmit: () => void
  onClose: () => void
}
const ExploreFilterDrawerForm = (props: FormProps) => {
  const { t } = useTranslation()
  const exploreFilterFormId = useId()

  const applyFilters = useAction(props.model.applyFilters)

  const resetFilters = useAction(props.model.resetFilters)
  const [filtersEditState] = useAtom(props.model.form.filtersEditState)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    applyFilters()
    props.onSubmit()
  }
  return (
    <Form id={exploreFilterFormId} onSubmit={handleSubmit}>
      <ExploreFilterForm model={props.model} />
      <Footer>
        <Separator />
        <Buttons>
          <Button
            variant="ghost"
            size="s"
            radius="rounded"
            type="button"
            iconLeft={<Refresh2Icon />}
            onClick={resetFilters}
            disabled={filtersEditState.isEmpty}
          >
            {t('common.filter_reset')}
          </Button>
          <Button
            variant="solid"
            color="primary"
            size="s"
            fullWidth
            radius="rounded"
            type="submit"
            disabled={!filtersEditState.isChanged}
          >
            {t('common.apply')}
          </Button>
        </Buttons>
      </Footer>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 12px;
`
const Footer = styled.footer`
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  background: var(--background-1);
  padding: 0 0 var(--safe-bottom);
`
const Buttons = styled.div`
  padding: 16px 0 8px;
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
`
